/*
 * Div1InputEmail.js: This component renders the input field and the Search button.
 *
 * The input field is used to enter the user's email address.
 * The email address must end with @nike.com or @converse.com.
 * Additionally, as soon as a user starts typing in the input field, Div2, Div3, and Div4 are set to invisible.
 */

import React from "react";
import isUsernameValid from "../../utils/isUsernameValid";
import "./Div1InputEmail.css";

const Div1InputGID = ({
  enteredEmail,
  setEnteredEmail,
  Div1SearchButtonClicked,
  setUserInfo,
  setDiv2Visible,
  apiProgress,
  setApiProgress,
  activeStep,
}) => {
  const handleInputChange = (event) => {
    setEnteredEmail(event.target.value);
    setUserInfo({});
    setDiv2Visible(false);
    setApiProgress(false);
  };

  const placeholderText = "Retail GID username";
  const isInputValid = isUsernameValid("retailGID", enteredEmail);

  return (
    <>
      <div
        className={`child-div form-div ${
          activeStep === 1 ? "active-step" : ""
        }`}
      >
        <input
          type="text"
          placeholder={placeholderText}
          value={enteredEmail}
          onChange={handleInputChange}
          onKeyDown={(e) => {
            if (
              e.key === "Enter" &&
              isInputValid &&
              !apiProgress 
            ) {
              Div1SearchButtonClicked();
            }
          }}
        />
        <button
          className={`app-button ${
            isInputValid && !apiProgress
              ? "button-valid"
              : "button-invalid"
          }`}
          disabled={!isInputValid || apiProgress}
          onClick={Div1SearchButtonClicked}
        >
          Search
        </button>
      </div>
    </>
  );
};

export default Div1InputGID;
